import ProviderAPI from "../redux/ProviderAPI";

export const getNationality = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/centerdata/nationality",
    data,
    token,
  });
  return result;
};

export const getCountry = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/centerdata/country",
    data,
    token,
  });
  return result;
};

export const getProvince = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/centerdata/province",
    data,
    token,
  });
  return result;
};

export const getDistrict = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/centerdata/district",
    data,
    token,
  });
  return result;
};

export const getSubDistrict = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/centerdata/Subdistrict",
    data,
    token,
  });
  return result;
};

export const getNameTitle = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/centerdata/detailNameTitle",
    data,
    token,
  });
  return result;
};

export const getBankName = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/centerdata/bankName",
    data,
    token,
  });
  return result;
};

export const getLegalEntity = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/centerdata/getLegalEntity",
    data,
    token,
  });
  return result;
};